import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import {
  Box,
  Checkbox,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ShareIcon from '@mui/icons-material/Share';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';
import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome';

const MapsAdvancedGeneralSettingsField = props => {
  const {
    listComponentsAdvanced,
    defaultComponent,
    showTooltip,
    sizeDrawer,
    setDefaultComponent,
    setSizeDrawer,
    setShowTooltip,
    settingsAdvanced,
    setSettingsAdvanced
  } = props;
  const [orderComponentState, setOrderComponentState] = React.useState(
    settingsAdvanced.orderOfComponents
  );

  const [localSettings, setLocalSettings] = React.useState(settingsAdvanced.buttonSettings);
  const [componentSelected, setComponentSelected] = React.useState(defaultComponent);
  const [sizeSelected, setSizeSelected] = React.useState(sizeDrawer);
  const [toolTip, setToolTip] = React.useState(showTooltip);
  const [openModalShareButton, setOpenModalShareButton] = React.useState(false);

  const valuesSizeDrawer = [
    { name: 'Cerrado', value: 0 },
    { name: '25%', value: 25 },
    { name: '33%', value: 100 / 3 },
    { name: '50%', value: 50 },
    { name: '75%', value: 75 },
    { name: '100%', value: 100 }
  ];

  const valuesTemplate = ['baseTemplate', 'baseTemplate1', 'baseTemplate2', 'baseTemplate3'];

  const handleMoveUp = index => {
    if (index > 0) {
      const newOrder = [...orderComponentState];
      const temp = newOrder[index];
      newOrder[index] = newOrder[index - 1];
      newOrder[index - 1] = temp;
      setOrderComponentState(newOrder);
      setSettingsAdvanced({ ...settingsAdvanced, orderOfComponents: newOrder });
    }
  };

  const handleMoveDown = index => {
    if (index < orderComponentState.length - 1) {
      const newOrder = [...orderComponentState];
      const temp = newOrder[index];
      newOrder[index] = newOrder[index + 1];
      newOrder[index + 1] = temp;
      setOrderComponentState(newOrder);
      setSettingsAdvanced({ ...settingsAdvanced, orderOfComponents: newOrder });
    }
  };

  const handleIconCurrentLocationSelected = (elementIcon, library) => {
    if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
      setLocalSettings({
        ...localSettings,
        shareButtonByMobile: {
          ...localSettings.shareButtonByMobile,
          iconFontawesome: elementIcon,
          libraryIcon: library
        }
      });
      setSettingsAdvanced(prev => ({
        ...prev,
        buttonSettings: {
          ...prev.buttonSettings,
          shareButtonByMobile: {
            ...prev.buttonSettings.shareButtonByMobile,
            iconFontawesome: elementIcon,
            libraryIcon: library
          }
        }
      }));
    } else if (library === LIBRARY_ICON_TYPES.SVG) {
      setLocalSettings({
        ...localSettings,
        shareButtonByMobile: {
          ...localSettings.shareButtonByMobile,
          iconFontawesome: elementIcon.name,
          iconSvg: elementIcon.url,
          libraryIcon: library,
          cetegorySvg: elementIcon.category
        }
      });
      setSettingsAdvanced(prev => ({
        ...prev,
        buttonSettings: {
          ...prev.buttonSettings,
          shareButtonByMobile: {
            ...prev.buttonSettings.shareButtonByMobile,
            iconFontawesome: elementIcon.name,
            iconSvg: elementIcon.url,
            libraryIcon: library,
            cetegorySvg: elementIcon.category
          }
        }
      }));
    } else {
      setLocalSettings({
        ...localSettings,
        shareButtonByMobile: {
          ...localSettings.shareButtonByMobile,
          libraryIcon: library
        }
      });
    }
  };

  return (
    <Box display="flex" width="100%">
      <Box display="column" width="40%" gab={1}>
        <FormControl fullWidth sx={{ mb: 1 }}>
          <InputLabel id="demo-select-label">Plantilla por defecto</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Plantilla por defecto"
            size="small"
            value={localSettings.templateDefault}
            onChange={event => {
              setLocalSettings({
                ...localSettings,
                templateDefault: event.target.value
              });
              setSettingsAdvanced(prev => ({
                ...prev,
                buttonSettings: {
                  ...prev.buttonSettings,
                  templateDefault: event.target.value
                }
              }));
              if (event.target.value === 'baseTemplate3') {
                setSizeDrawer({ name: '100%', value: 100 });
                setSizeSelected({ name: '100%', value: 100 });
              }
            }}
          >
            {valuesTemplate.map(item => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ mb: 1 }}>
          <InputLabel id="demo-select-label">Componente por defecto</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Componente por defecto"
            size="small"
            value={componentSelected}
            onChange={event => {
              setDefaultComponent(event.target.value);
              setComponentSelected(event.target.value);
            }}
          >
            {orderComponentState.map(key => (
              <MenuItem key={key} value={key}>
                {listComponentsAdvanced[key].name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ mb: 1 }}>
          <InputLabel id="demo-select-label">Ancho del componente</InputLabel>
          <Select
            labelId="demo-select-label"
            id="demo-select"
            label="Ancho del componente"
            size="small"
            value={sizeSelected.name}
            onChange={event => {
              const select = valuesSizeDrawer.find(element => element.name === event.target.value);
              setSizeDrawer(select);
              setSizeSelected(select);
            }}
          >
            {valuesSizeDrawer.map(item => (
              <MenuItem key={item.name} value={item.name}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box display="row" justifyContent="space-evenly" fullWidth mb={2}>
          <Checkbox
            checked={toolTip === true}
            onChange={() => {
              setShowTooltip(!toolTip);
              setToolTip(!toolTip);
            }}
            sx={{
              color: '#2A3F90',
              '&.Mui-checked': {
                color: '#2A3F90'
              }
            }}
            value="toolTip"
          />
          Mostrar información de los botones
        </Box>
        <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
          <Checkbox
            checked={localSettings.showAjustarMapa}
            onChange={() => {
              setLocalSettings({
                ...localSettings,
                showAjustarMapa: !localSettings.showAjustarMapa
              });
              setSettingsAdvanced(prev => ({
                ...prev,
                buttonSettings: {
                  ...prev.buttonSettings,
                  showAjustarMapa: !localSettings.showAjustarMapa
                }
              }));
            }}
            sx={{
              color: '#2A3F90',
              '&.Mui-checked': {
                color: '#2A3F90'
              }
            }}
            value="showVideo"
          />
          Mostrar botón ajustar mapa
        </Box>
        <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
          <Checkbox
            checked={localSettings.showChangeSize}
            onChange={() => {
              setLocalSettings({
                ...localSettings,
                showChangeSize: !localSettings.showChangeSize
              });
              setSettingsAdvanced(prev => ({
                ...prev,
                buttonSettings: {
                  ...prev.buttonSettings,
                  showChangeSize: !localSettings.showChangeSize
                }
              }));
            }}
            sx={{
              color: '#2A3F90',
              '&.Mui-checked': {
                color: '#2A3F90'
              }
            }}
            value="showChangeSize"
          />
          Show buttons to resize the slider
        </Box>
        <Box display="row" justifyContent="space-evenly" fullwidth="true" mb={2}>
          <Checkbox
            checked={localSettings.showModal}
            onChange={() => {
              setLocalSettings({
                ...localSettings,
                showModal: !localSettings.showModal
              });
              setSettingsAdvanced(prev => ({
                ...prev,
                buttonSettings: {
                  ...prev.buttonSettings,
                  showModal: !localSettings.showModal
                }
              }));
            }}
            sx={{
              color: '#2A3F90',
              '&.Mui-checked': {
                color: '#2A3F90'
              }
            }}
            value="showModal"
          />
          Show button to open modal.
        </Box>
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%'
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-required"
            label="Enter a title for the coordinates button"
            size="small"
            focused
            value={localSettings.shareButtonByMobile.name}
            onChange={event => {
              setSettingsAdvanced(prev => ({
                ...prev,
                buttonSettings: {
                  ...prev.buttonSettings,
                  shareButtonByMobile: {
                    ...prev.buttonSettings.shareButtonByMobile,
                    name: event.target.value
                  }
                }
              }));
              setLocalSettings({
                ...localSettings,
                shareButtonByMobile: {
                  ...localSettings.shareButtonByMobile,
                  name: event.target.value
                }
              });
            }}
            mb={2}
            fullWidth
          />
          <IconButton
            onClick={() => setOpenModalShareButton(true)}
            style={{
              color: '#2A3F90'
            }}
          >
            {!isEmpty(localSettings.shareButtonByMobile.libraryIcon) ? (
              <>
                {localSettings.shareButtonByMobile.libraryIcon ===
                  LIBRARY_ICON_TYPES.FONTAWESOME && (
                  <FontAwesomeIcon icon={localSettings.shareButtonByMobile.iconFontawesome} />
                )}
                {localSettings.shareButtonByMobile.libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                  <img
                    src={localSettings.shareButtonByMobile.iconSvg}
                    alt={localSettings.shareButtonByMobile.iconFontawesome}
                    style={{ marginRight: '5px', width: '20px', height: '20px' }}
                  />
                )}
              </>
            ) : (
              <ShareIcon />
            )}
          </IconButton>
          <ShowListIconsFontawesome
            openModal={openModalShareButton}
            setOpenModal={setOpenModalShareButton}
            handleIconSelected={handleIconCurrentLocationSelected}
            selectedIcon={localSettings.shareButtonByMobile.iconFontawesome}
            startLibrary={localSettings.shareButtonByMobile.libraryIcon}
            svg={localSettings.shareButtonByMobile.iconSvg}
            startCategorySvg={localSettings.shareButtonByMobile.cetegorySvg}
          />
        </Box>
      </Box>
      <Box display="column" width="40%">
        <Box sx={{ display: 'flex', flexDirection: 'row', overflowY: 'auto', m: 2 }}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Components</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {orderComponentState.map((key, index) => (
                  <TableRow key={key}>
                    <TableCell>{listComponentsAdvanced[key].name}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => handleMoveUp(index)} disabled={index === 0}>
                        <KeyboardArrowUpIcon />
                      </IconButton>
                      <IconButton
                        onClick={() => handleMoveDown(index)}
                        disabled={index === orderComponentState.length - 1}
                      >
                        <KeyboardArrowDownIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </Box>
  );
};
export default MapsAdvancedGeneralSettingsField;
MapsAdvancedGeneralSettingsField.defaultProps = {
  showTooltip: false,
  defaultComponent: '',
  sizeDrawer: {}
};
MapsAdvancedGeneralSettingsField.propTypes = {
  defaultComponent: PropTypes.string,
  listComponentsAdvanced: PropTypes.object.isRequired,
  settingsAdvanced: PropTypes.object.isRequired,
  setDefaultComponent: PropTypes.func.isRequired,
  setSettingsAdvanced: PropTypes.func.isRequired,
  setSizeDrawer: PropTypes.func.isRequired,
  setShowTooltip: PropTypes.func.isRequired,
  sizeDrawer: PropTypes.object,
  showTooltip: PropTypes.bool
};
